import { gql } from "@/services/httpAdapter";

export const TreeNodeFragment = gql`
    fragment TreeNode on GenericTreeItem {
        _id
        title
        bold
        disabled
        controlled
        itemCount
    }
`;